export const CALL_PERMISSION_REASONS = {
  CONTACT_NOT_FOUND: 'CONTACT_NOT_FOUND',
  CONTACT_BLOCKED: 'CONTACT_BLOCKED',
  PERMANENT_PERMISSION: 'PERMANENT_PERMISSION',
  TEMPORARY_PERMISSION_VALID: 'TEMPORARY_PERMISSION_VALID',
  CALL_PERMISSION_EXPIRED: 'CALL_PERMISSION_EXPIRED',
  CALL_PERMISSION_NOT_AVAILABLE: 'CALL_PERMISSION_NOT_AVAILABLE',
};

export const canBusinessInitiateCall = (contact) => {
  const currentTimestamp = Math.floor(Date.now() / 1000);

  if (!contact) {
    return {
      canCall: false,
      reason: CALL_PERMISSION_REASONS.CONTACT_NOT_FOUND,
      message: 'Contact not found.',
    };
  }

  if (contact?.isBlocked === true) {
    return {
      canCall: false,
      reason: CALL_PERMISSION_REASONS.CONTACT_BLOCKED,
      message: 'Contact is blocked. Business cannot initiate call.',
    };
  }

  const isPermanent = contact?.callPermissionIsPermanent;
  const rawExpiry =
    contact?.callPermissionExpiryTimeStamp ??
    contact?.expiration_timestamp ??
    contact?.call_permission_reply?.expiration_timestamp;
  const expiryTimestamp =
    rawExpiry === null || rawExpiry === undefined || rawExpiry === ''
      ? null
      : Number(rawExpiry);
  const hasValidExpiryTimestamp =
    Number.isFinite(expiryTimestamp) && expiryTimestamp > 0;

  if (isPermanent === true) {
    return {
      canCall: true,
      reason: CALL_PERMISSION_REASONS.PERMANENT_PERMISSION,
      message:
        'Business can initiate call because customer has given permanent call permission.',
    };
  }

  if (
    isPermanent === false &&
    hasValidExpiryTimestamp &&
    expiryTimestamp > currentTimestamp
  ) {
    return {
      canCall: true,
      reason: CALL_PERMISSION_REASONS.TEMPORARY_PERMISSION_VALID,
      message:
        'Business can initiate call because temporary call permission is still valid.',
    };
  }

  if (
    isPermanent === false &&
    hasValidExpiryTimestamp &&
    expiryTimestamp <= currentTimestamp
  ) {
    return {
      canCall: false,
      reason: CALL_PERMISSION_REASONS.CALL_PERMISSION_EXPIRED,
      message: 'Call permission has expired. Please request call permission again.',
    };
  }

  return {
    canCall: false,
    reason: CALL_PERMISSION_REASONS.CALL_PERMISSION_NOT_AVAILABLE,
    message: 'Customer has not given call permission yet.',
  };
};

export const getCallPermissionExpiryTimestamp = (contact) => {
  const rawExpiry =
    contact?.callPermissionExpiryTimeStamp ??
    contact?.expiration_timestamp ??
    contact?.call_permission_reply?.expiration_timestamp;

  const expiryTimestamp =
    rawExpiry === null || rawExpiry === undefined || rawExpiry === ''
      ? null
      : Number(rawExpiry);

  return Number.isFinite(expiryTimestamp) && expiryTimestamp > 0 ? expiryTimestamp : null;
};

export const formatCallPermissionTimestamp = (unixSeconds) => {
  if (!unixSeconds) return '';

  const date = new Date(Number(unixSeconds) * 1000);
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(date);
};
